/**
 * AEB参数-批量设置表单
 */
import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { Form } from 'antd';
import ConfigForm from '@/components/configForm';
import { getLXConfigParams } from '@/constants/parameterConfiguration';
import { filterFormValues } from '@/utils/useFormToJsonString';

export interface AebParamsWriteFormRef {
  getSubmitString: () => Promise<string | null>;
}

const AebParamsWriteForm = forwardRef<AebParamsWriteFormRef, {}>((props, ref) => {
  const [form] = Form.useForm();
  const [activeKeys, setActiveKeys] = useState<string[]>([]);

  // Collapse激活状态改变
  const handleCollapseChange = (keys: string | string[]) => {
    setActiveKeys(Array.isArray(keys) ? keys : [keys]);
  };

  // 导出方法：获取表单数据的JSON字符串
  useImperativeHandle(ref, () => ({
    getSubmitString: async () => {
      const values = await form.validateFields();
      console.log('AebParamsWriteForm values:', values);
      return filterFormValues(values);
    }
  }));

  // 获取配置并设置所有表单项为非必填
  const getOptionalFormConfig = () => {
    const config = getLXConfigParams();
    // 深拷贝配置，避免影响其他地方的使用
    const clonedConfig = JSON.parse(JSON.stringify(config));
    
    // 遍历所有面板，将所有表单项标记为非必填
    clonedConfig.forEach((panel: any) => {
      if (panel.formItems && Array.isArray(panel.formItems)) {
        panel.formItems.forEach((formItemRow: any) => {
          if (Array.isArray(formItemRow)) {
            formItemRow.forEach((formItem: any) => {
              // 设置judgeRequired为true，让ConfigForm跳过必填判断
              formItem.judgeRequired = true;
            });
          }
        });
      }
    });
    
    return clonedConfig;
  };

  return (
    <Form form={form}>
    <ConfigForm
      formConfig={getOptionalFormConfig()}
      form={form}
      originData={{}} 
      showCollapse={true}
      activeKeys={activeKeys}
      onCollapseChange={handleCollapseChange}
    />
    </Form>
  );
});

export default AebParamsWriteForm;
